/**
 * menu
 */

import $ from 'jquery';
import Page from '~/page/page';

import anime from 'animejs';

export default class Menu extends Page {
  init() {
    this.elements({
      open: '.js-menu-open',
      close: '.js-menu-close',
      inner: '.js-menu-inner',
      link: '.js-menu-link',
      sublist: '.js-menu-sublist'
    });
  }
  events() {
    this.$.document.on('click', e => this.handler(e));
    this.$.window.on('keydown', e => this.handler(e));
    this.$.close.on('click', e => this.close(e));
    this.$.link.on('click', e => this.toggle(e));
  }
  handler(e) {
    const methods = {
      click: this.click,
      keydown: this.keydown
    };

    const type = e.type;
    const method = methods[type];

    method.call(this, e);
  }
  click(e) {
    const $target = $(e.target);

    if ($target.is(this.$.open)) {
      e.preventDefault();
      this.open();
    } else {
      if (!$target.closest(this.$.root).length) {
        this.close();
      }
    }
  }
  keydown(e) {
    if (e.keyCode === 27) {
      this.close();
    }
  }
  toggle(e) {
    if (this.$.window.width() > 560) return;

    e.preventDefault();

    const $target = $(e.target);
    const $sublist = $target.siblings(this.$.sublist);

    console.log($target);
    $sublist.slideToggle(300);
    $target.parent().toggleClass('is-open');
  }
  open() {
    this.$.root.addClass('is-open');
    this.$.body.addClass('menu-open');
    this.$.inner.css({ opacity: 0, display: 'flex' });

    anime({
      targets: this.$.inner.get(0),
      translateX: [{ value: '100%', duration: 0 }, { value: 0, duration: 500 }],
      opacity: [{ value: 1, duration: 500 }],
      easing: 'easeInOutQuint'
    });
  }
  close() {
    anime({
      targets: this.$.inner.get(0),
      duration: 400,
      translateX: '100%',
      opacity: 0,
      easing: 'easeInOutQuint',
      complete: () => {
        this.$.root.removeClass('is-open');
        this.$.body.removeClass('menu-open');
        this.$.inner.css({ display: 'none' });
      }
    });
  }
}

Page.mount(Menu, '.js-menu');
